export default __webpack_public_path__ + "images/ic_open.png";